var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoUrl)?_c('iframe',{attrs:{"width":_vm.$vuetify.breakpoint.xs ? '100%' : 640,"height":"390","src":_vm.videoUrl,"frameborder":"0","title":"YouTube video player","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }